import React from "react";
import PropTypes from "prop-types";
import { TREE_STATUS } from "@constants";
import { SectionContentItem } from "./SectionContentItem";
import styles from "./style/CourseContentTree.module.css";

const SectionContentTree = (props) => {
  const { sectionList, treeStatus } = props;

  return (
    <div className={styles.container}>
      {sectionList.map((section, index) => {
        return (
          <SectionContentItem
            key={section.id}
            section={section}
            index={index}
            isExpand={treeStatus === TREE_STATUS.EXPAND_ALL}
          />
        );
      })}
    </div>
  );
};

/* required: display name */
SectionContentTree.displayName = "SectionContentTree";

/* required: props types */
SectionContentTree.propTypes = {
  sectionList: PropTypes.array,
  treeStatus: PropTypes.string,
};

/* required: default props */
SectionContentTree.defaultProps = {
  treeStatus: TREE_STATUS.NORMAL,
};

export { SectionContentTree };
